const hotel = {
  availableMealPlans: "Pelan Makanan yang Tersedia", // translated 
  availableRoomsTypes: "Jenis Bilik yang Tersedia", // translated 
  cancellationPolicy: "Polisi Pembatalan", // translated 
  cancellationRules: "Peraturan Pembatalan", // translated 
  freeCancellationAvailable: "Pembatalan Percuma Tersedia", // translated 
  nonRefundable: "Tidak Boleh Dikembalikan", // translated 
  priceFor: "Harga untuk", // translated 
  nights: "malam-malam", // translated 
  totalPrice: "Jumlah harga", // translated 
  seeAvailability: "Lihat Ketersediaan", // translated 
  myProfile: "Profil Saya", // translated 
  travelTrust: "Amanah Perjalanan", // translated 
  signIn: "Daftar Masuk", // translated 
  searchNow: "Cari Sekarang", // translated 
  policy: "Dasar", // translated 
  cxlRules: "Peraturan CXL", // translated 
  room: "bilik", // translated 
  cxlPolicy: "Dasar CXL", // translated 
  beddingType: "Jenis Katil", // translated 
  hotelName: "Nama Hotel", // translated 
  reservationDate: "Tarikh Tempahan", // translated 
  maxPax: "Max Pax", // translated 
};







export default hotel;
